import { Base } from "../../framework/base";
import { RecordFurtherEducationGroupNode } from "../recordFurtherEducationGroup/recordFurtherEducationGroupNode";
import { Translations } from "../translations";
import { RecordQualificationUserFurtherEducation } from "./recordQualificationUserFurtherEducation";
var RecordListItemUserQualification = /** @class */ (function () {
    function RecordListItemUserQualification(obj) {
        this.id = obj && obj.id || "";
        this.furtherEducationId = obj && obj.furtherEducationId || "";
        this.furtherEducationGroupId = obj && obj.furtherEducationGroupId || "";
        this.code = obj && obj.code || "";
        this.requiredQualificationCount = obj && obj.requiredQualificationCount || 0;
        this.userFurtherEducations = Base.getTypedArray(obj ? obj.userFurtherEducations : null, RecordQualificationUserFurtherEducation);
        this.validUserFurtherEducations = Base.getTypedArray(obj ? obj.validUserFurtherEducations : null, RecordQualificationUserFurtherEducation);
        this.valid = obj && obj.valid || false;
        this.validityEndDate = obj && obj.validityEndDate || null;
    }
    RecordListItemUserQualification.getFurtherEducationCodeAndValidityData = function (userFurtherEducations, furtherEducationId) {
        var result = {
            furtherEducationId: furtherEducationId,
            recordUserFurtherEducationId: "",
            furtherEducationValid: false,
            furtherEducationValidityEndDate: null
        };
        if (!furtherEducationId)
            return result;
        var relevantUserFurtherEducations = userFurtherEducations.filter(function (i) { return i.furtherEducationId === furtherEducationId && !i.getIsArchived(); });
        if (relevantUserFurtherEducations.length < 1)
            return result;
        relevantUserFurtherEducations.sort(function (a, b) {
            var _a, _b;
            if (!a || !b)
                return 0;
            return -1 * Base.numCompare((_a = a.validityEndDate) !== null && _a !== void 0 ? _a : Number.MAX_VALUE, (_b = b.validityEndDate) !== null && _b !== void 0 ? _b : Number.MAX_VALUE);
        });
        var recordUserFurtherEducation = relevantUserFurtherEducations[0];
        var validityEndDate = recordUserFurtherEducation.validityEndDate;
        result.recordUserFurtherEducationId = recordUserFurtherEducation.id;
        result.furtherEducationValidityEndDate = validityEndDate;
        result.furtherEducationValid = !validityEndDate || validityEndDate >= Base.getNowDateTicks();
        return result;
    };
    RecordListItemUserQualification.getFurtherEducationCodeAndValidityDatas = function (userFurtherEducations, furtherEducationIds) {
        var result = [];
        if (!furtherEducationIds || !furtherEducationIds.length)
            return result;
        var relevantUserFurtherEducations = userFurtherEducations.filter(function (i) { return furtherEducationIds.indexOf(i.furtherEducationId) > -1 && !i.getIsArchived(); });
        if (relevantUserFurtherEducations.length < 1)
            return result;
        relevantUserFurtherEducations.sort(function (a, b) {
            var _a, _b;
            if (!a || !b)
                return 0;
            return -1 * Base.numCompare((_a = a.validityEndDate) !== null && _a !== void 0 ? _a : Number.MAX_VALUE, (_b = b.validityEndDate) !== null && _b !== void 0 ? _b : Number.MAX_VALUE);
        });
        return relevantUserFurtherEducations.map(function (i) {
            return {
                furtherEducationId: i.furtherEducationId,
                recordUserFurtherEducationId: i.id,
                furtherEducationValidityEndDate: i.validityEndDate,
                furtherEducationValid: !i.validityEndDate || i.validityEndDate >= Base.getNowDateTicks()
            };
        });
    };
    RecordListItemUserQualification.setCodeAndValidity = function (qualification, furtherEducationGroups, userFurtherEducations) {
        qualification.code = "";
        qualification.userFurtherEducations = [];
        qualification.validUserFurtherEducations = [];
        qualification.requiredQualificationCount = 0;
        if (qualification.furtherEducationId) {
            var furtherEducation = RecordFurtherEducationGroupNode.getRecordFurtherEducationById(furtherEducationGroups, qualification.furtherEducationId);
            if (!furtherEducation)
                return;
            qualification.code = furtherEducation.code;
            var data = RecordListItemUserQualification.getFurtherEducationCodeAndValidityData(userFurtherEducations, qualification.furtherEducationId);
            if (!data.recordUserFurtherEducationId)
                return;
            qualification.userFurtherEducations.push(RecordQualificationUserFurtherEducation.Create(data.recordUserFurtherEducationId, qualification.code, data.furtherEducationValid, data.furtherEducationValidityEndDate));
        }
        else if (qualification.furtherEducationGroupId) {
            var furtherEducationGroup = RecordFurtherEducationGroupNode.getRecordFurtherEducationGroupNodeById(furtherEducationGroups, qualification.furtherEducationGroupId);
            if (!furtherEducationGroup)
                return;
            qualification.code = furtherEducationGroup.code;
            qualification.requiredQualificationCount = furtherEducationGroup.requiredQualificationCount;
            var data = RecordListItemUserQualification.getFurtherEducationCodeAndValidityDatas(userFurtherEducations, furtherEducationGroup.children.map(function (i) { return i.id; }));
            for (var _i = 0, data_1 = data; _i < data_1.length; _i++) {
                var item = data_1[_i];
                var furtherEducation = RecordFurtherEducationGroupNode.getRecordFurtherEducationById(furtherEducationGroups, item.furtherEducationId);
                qualification.userFurtherEducations.push(RecordQualificationUserFurtherEducation.Create(item.recordUserFurtherEducationId, furtherEducation.code, item.furtherEducationValid, item.furtherEducationValidityEndDate));
            }
        }
        RecordQualificationUserFurtherEducation.sortRecordQualificationUserFurtherEducation(qualification.userFurtherEducations, "validityEndDate", true);
        qualification.validUserFurtherEducations = qualification.userFurtherEducations.filter(function (i) { return i.valid; });
        qualification.valid = qualification.requiredQualificationCount > 0
            ? qualification.validUserFurtherEducations.length >= qualification.requiredQualificationCount
            : qualification.validUserFurtherEducations.length > 0;
        var validityEndDates = qualification.validUserFurtherEducations.filter(function (i) { return i.validityEndDate; }).map(function (i) { return i.validityEndDate; });
        qualification.validityEndDate = qualification.valid && validityEndDates.length
            ? Math.min.apply(Math, validityEndDates) : null;
    };
    RecordListItemUserQualification.setFurtherEducationCodesAndValidity = function (qualifications, furtherEducationGroups, userFurtherEducations) {
        for (var _i = 0, qualifications_1 = qualifications; _i < qualifications_1.length; _i++) {
            var qualification = qualifications_1[_i];
            RecordListItemUserQualification.setCodeAndValidity(qualification, furtherEducationGroups, userFurtherEducations);
        }
    };
    RecordListItemUserQualification.getValidQualificationNumberStr = function (qualification) {
        return (qualification.furtherEducationGroupId
            ? " (" + qualification.validUserFurtherEducations.length.toString(10) + " / " + qualification.requiredQualificationCount.toString(10) + ")"
            : "");
    };
    RecordListItemUserQualification.getQualificationState = function (qualification) {
        return (qualification.userFurtherEducations.length
            ? (qualification.valid
                ? Translations.Valid
                : Translations.Missing)
            : Translations.Missing) + RecordListItemUserQualification.getValidQualificationNumberStr(qualification);
        // return (qualification.userFurtherEducations.length
        //     ? (qualification.valid
        //         ? Translations.Valid
        //         : (!qualification.furtherEducationGroupId
        //             ? Translations.Expired
        //             : Translations.NotValid))
        //     : Translations.Missing) + RecordListItemUserQualification.getValidQualificationNumberStr(qualification);
    };
    return RecordListItemUserQualification;
}());
export { RecordListItemUserQualification };
